import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { grey } from '@mui/material/colors';

const OutlinedButton = styled(Button)(({ color }) => {

  var stylesObj = {    
    backgroundColor: '#fff',
    textTransform: 'capitalize',
    fontFamily: 'InterRegular',
    fontSize: '14px',
    paddingTop: '10px',
    paddingBottom: '10px',
    '&:hover': {
      backgroundColor: grey['100'],
    },
  };
  if (color != 'error')
  {
    stylesObj.color = '#344054';
    stylesObj.borderColor = '#DBDBE0';
  }

  return (stylesObj)
});

export default function CustomizedButtons({ onClick, startIcon, title, href, disabled, sx, color }) {
  return (
    <OutlinedButton sx={sx} disabled={disabled} variant="outlined" onClick={onClick} href={href} startIcon={startIcon} color={color} >{title}</OutlinedButton>
  );
}